export default defineNuxtPlugin(() => {
  const loadBanner = () => {
    const link = document.createElement('link')
    link.rel = 'stylesheet'
    link.href = '/js/smart-app-banner.css'
    document.head.appendChild(link)

    const script = document.createElement('script')
    script.src = '/js/smart-app-banner.js'
    script.async = true
    script.onload = () => {
      window.dispatchEvent(new Event('smartbanner:ready'))

      const fixCloseBtn = () => {
        const closeLink = document.querySelector('a.smartbanner-close') as HTMLElement | null
        if (closeLink) {
          const btn = document.createElement('button')
          btn.className = closeLink.className
          btn.innerHTML = closeLink.innerHTML
          btn.setAttribute('aria-label', 'Close')
          const computedStyle = window.getComputedStyle(closeLink)
          btn.style.cssText = `
            background: none;
            border: none;
            padding: ${computedStyle.padding};
            margin: ${computedStyle.margin};
            position: ${computedStyle.position};
            top: ${computedStyle.top};
            left: ${computedStyle.left};
            right: ${computedStyle.right};
            font-size: ${computedStyle.fontSize};
            color: ${computedStyle.color};
            line-height: ${computedStyle.lineHeight};
            cursor: pointer;
            display: ${computedStyle.display};
            width: ${computedStyle.width};
            height: ${computedStyle.height};
            text-align: center;
          `
          btn.addEventListener('click', () => {
            closeLink.click()
          })
          closeLink.replaceWith(btn)
          return true
        }
        return false
      }

      if (!fixCloseBtn()) {
        const observer = new MutationObserver(() => {
          if (fixCloseBtn()) observer.disconnect()
        })
        observer.observe(document.body, { childList: true, subtree: true })
        setTimeout(() => observer.disconnect(), 5000)
      }
    }
    document.head.appendChild(script)
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(loadBanner, { timeout: 5000 })
  } else {
    setTimeout(loadBanner, 4000)
  }
})
